import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import RetakeExamButton from './RetakeExamButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ExamCertificationExpiredScreen = ({
  track,
  award,
  mostRecentExamAttempt,
  pendingPracticalExercises
}) => {
  var _track$exam;
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    callToAction: /*#__PURE__*/_jsx(RetakeExamButton, {
      mostRecentExamAttempt: mostRecentExamAttempt,
      use: "primary"
    }),
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.isExpiredHeader"
    }),
    illustration: /*#__PURE__*/_jsx(Illustration, {
      name: "announcement"
    }),
    mostRecentExamAttempt: mostRecentExamAttempt,
    pendingPracticalExercises: pendingPracticalExercises,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourPreviousScoreWas",
      options: {
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && ((_track$exam = track.exam) === null || _track$exam === void 0 ? void 0 : _track$exam.length) || 0
      }
    }),
    subheading: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.exams.finished.isExpired",
      options: {
        expiryDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "ll",
          value: (award === null || award === void 0 ? void 0 : award.expiresAt) || 0
        })
      }
    }),
    track: track
  });
};
export default ExamCertificationExpiredScreen;